import { render, staticRenderFns } from "./ShowImg.vue?vue&type=template&id=87db3e38&scoped=true"
import script from "./ShowImg.vue?vue&type=script&lang=js"
export * from "./ShowImg.vue?vue&type=script&lang=js"
import style0 from "./ShowImg.vue?vue&type=style&index=0&id=87db3e38&prod&lang=stylus&scoped=true"
import style1 from "./ShowImg.vue?vue&type=style&index=1&id=87db3e38&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87db3e38",
  null
  
)

export default component.exports